export const COLORS = [
    {'id': 1, 'color': '#FF4747'},
    {'id': 2, 'color': '#75D1E0'},
    {'id': 3, 'color': '#E8B171'},
    {'id': 4, 'color': '#EFEFEF'},
    {'id': 5, 'color': '#8FB872'},
    {'id': 6, 'color': '#5a2f21'},
    {'id': 7, 'color': '#805ABE'},
    {'id': 8, 'color': '#262626'},
]